module.exports = __webpack_public_path__ + "static/Icon_FindTeam_Large-b900845037ddc401702976bcd538db47.png";